__turbopack_context__.v({
  "prompt": "DIzqOq_prompt",
  "prompt-wrapper": "DIzqOq_prompt-wrapper",
  "prompt__close-button": "DIzqOq_prompt__close-button",
  "prompt__install-button": "DIzqOq_prompt__install-button",
  "prompt__message": "DIzqOq_prompt__message",
});
